import {api} from "../../../../api/API";
import {useAsync2} from "nate-react-api-helpers";
import {useProjectId} from "../ProjectName";
import {columnCount} from "./Keying2";
import {NativeAutoComplete} from "../hardware/NativeAutoComplete";
import {Keying2PendingItem, Keying2Shortcode} from "../../../../api/Keying2";
import * as React from "react";
import {useReload} from "../hardware/ReloadContext";
import {useContext, useState} from "react";
import {leftIndent} from "./ShortCode";
import {css} from "@emotion/css";
import {grey} from "@mui/material/colors";
import {makeCreateShortcode} from "./CreateShortCode";
import {KeyingEditingContext} from "./KeyingEditingContextProvider";
import {Checkbox, Chip} from "@mui/material";

export function Pending(props: {
    onShortcodes(search: string, opening: boolean): Keying2Shortcode[];
    labelCount: number;
}) {

    const project = useProjectId();
    const [includeUnkeyed, setIncludeUnkeyed] = useState(false);
    const list = useAsync2(input => api.keying2.getPending(input), {project: project, includeUnkeyed}, [project, includeUnkeyed]);
    useReload(list.reload, [list.reload]);


    return (
        <>
            <tr>
                <td colSpan={columnCount + props.labelCount} style={{fontWeight: "600"}}>Pending</td>
            </tr>
            {list.loadingOrError && <tr key="pending-loading">
                <td colSpan={columnCount + props.labelCount}>{list.LoadingElement}</td>
            </tr>}
            {list.asList.map(l => (
                <PendingRow key={l.opening || l.miscProduct} labelCount={props.labelCount} value={l}
                    onShortcodes={props.onShortcodes}
                />
            ))}

            <tr>
                <td>
                    <Checkbox
                        checked={includeUnkeyed}
                        onChange={e => setIncludeUnkeyed(e.target.checked)}
                    />
                    Show unkeyed
                </td>
            </tr>
        </>
    )

}

function PendingRow(props: {
    value: Keying2PendingItem
    labelCount: number;
    onShortcodes(search: string, opening: boolean): Keying2Shortcode[]
}) {
    const project = useProjectId();
    const editCtx = useContext(KeyingEditingContext);

    return (
        <>
            <tr className={greyRow}>
                <td colSpan={columnCount + props.labelCount - 2}>
                    <div style={{
                        paddingLeft: leftIndent
                    }}>
                        {props.value.name}
                        {!props.value.isKeyed && " (Not Keyed)"}
                        {props.value.baseBuilding && <Chip label="Base Building" size="small" variant="outlined" style={{height: 18, fontSize: "0.75em", marginLeft: 6}} />}
                    </div>
                </td>
                <td style={{textAlign: "right"}}>
                    {props.value.qty}
                </td>
                <td />
            </tr>
            <tr className={greyRow}>
                <td colSpan={columnCount + props.labelCount}>
                    <div style={{paddingLeft: leftIndent}}>
                        <NativeAutoComplete<Keying2Shortcode>
                            placeholder="Assign to shortcode"
                            onSearch={async search => props.onShortcodes(search, !!props.value.opening)}
                            makeLabel={v => v.name}
                            onAssign={v => {
                                editCtx.onEdit({
                                    id: v.id,
                                    add: props.value,
                                })
                            }}
                            onCreate={v => {
                                const value = makeCreateShortcode({
                                    project: project,
                                    name: v,
                                });

                                if(props.value.opening) {
                                    value.openings?.push({
                                        id: props.value.opening,
                                        name: props.value.name,
                                        locationTwo: props.value.locationTwo,
                                        baseBuilding: props.value.baseBuilding,
                                    } as any);
                                }

                                if(props.value.miscProduct) {
                                    value.miscItems?.push({
                                        id: props.value.miscProduct,
                                        name: props.value.name,
                                    } as any);
                                }

                                editCtx.onEdit({
                                    id: value.id,
                                    defaultValue: value,
                                })
                            }} />
                    </div>
                </td>
            </tr>
        </>
    )
}

const greyRow = css({
    "& > td": {
        backgroundColor: grey["200"],
    },
    "& input": {
        backgroundColor: "transparent",
    }
})